// extracted by mini-css-extract-plugin
export default {"root":"messenger__root__UUInE","body":"messenger__body__Z8ktY","error":"messenger__error__TuMW5","closeBtn":"messenger__closeBtn__A6Lp4","success":"messenger__success__AgAbY"};